import {
    Site,
    ProductType as LegacyProductType,
} from '@superbet-group/web.types';

import { productNapoleonCasino } from '@app/router/products/productNapoleonCasino';
import { productNapoleonDice } from '@app/router/products/productNapoleonDice';
import { productNapoleonGames } from '@app/router/products/productNapoleonGames';
import { productNapoleonSports } from '@app/router/products/productNapoleonSports';
import { productSuperbetCom } from '@app/router/products/productSuperbetCom';
import { productSuperbetBr } from '@app/router/products/productSuperbetBr';
import { productSuperbetPl } from '@app/router/products/productSuperbetPl';
import { productSuperbetRo } from '@app/router/products/productSuperbetRo';
import { productSuperbetRs } from '@app/router/products/productSuperbetRs';
import { productSuperbetBg } from '@app/router/products/productSuperbetBg';
import { productSuperSocialBr } from '@app/router/products/productSuperSocialBr';
import { productNapoleonGamesRo } from '@app/router/products/productNapoleonGamesRo';
import { Product as ProductType } from '@app/router/types';
import { currentSite } from '@app/utils/domainHelpers';
import { productSuperbetBetlerPl } from '@app/router/products/productSuperbetBetlerPl';

export const SiteProduct: Record<Site, ProductType> = {
    [Site.SuperbetRo]: productSuperbetRo,
    [Site.SuperbetPl]: productSuperbetPl,
    [Site.SuperbetRs]: productSuperbetRs,
    [Site.SuperbetCom]: productSuperbetCom,
    [Site.SuperbetBr]: productSuperbetBr,
    [Site.NapoleonDice]: productNapoleonDice,
    [Site.NapoleonGames]: productNapoleonGames,
    [Site.NapoleonCasino]: productNapoleonCasino,
    [Site.NapoleonSports]: productNapoleonSports,
    [Site.SuperbetBg]: productSuperbetBg,
    [Site.SuperSocialBr]: productSuperSocialBr,
    [Site.NapoleonGamesRo]: productNapoleonGamesRo,
    [Site.SuperbetBetlerPl]: productSuperbetBetlerPl,
};

export const Product = SiteProduct[currentSite];

export const LegacyProduct: Record<LegacyProductType, boolean> = {
    [LegacyProductType.Base]: Product.Sport,
    [LegacyProductType.Casino]: Product.Games,
    [LegacyProductType.CasinoLive]: Product.CasinoLive,
    [LegacyProductType.Virtual]: Product.Virtual,
    [LegacyProductType.News]: Product.News,
    [LegacyProductType.Lotto]: Product.Lottery,
    [LegacyProductType.Shops]: Product.Shops,
    [LegacyProductType.Sport]: Product.Sport,
    [LegacyProductType.SportSpecials]: false,
    [LegacyProductType.SuperSpin]: Product.Free2Play.SuperSpin,
};
